export const insuranceData = [
  {
    _id: 'ins_1',
    name: 'MSME Property & Asset Shield',
    slug: 'msme-property-asset-shield',
    category: 'property',
    partner: {
      _id: 'p_1',
      name: 'ICICI Lombard General Insurance',
      logo: '/partners/icici.png',
    },
    description: 'Comprehensive property risk coverage for Indian MSME factories, warehouses, rented workshops, office spaces, and raw material inventories against fire, flood, and equipment breakdown.',
    minPremium: 4999,
    maxPremium: 45000,
    coverageDetails: [
      'Fire, lightning, explosion, and aircraft damage',
      'Natural calamities including flood, inundation, cyclone, and earthquake',
      'Burglary, housebreaking, and plant robbery',
      'Electronic equipment and server hardware accidental damage',
      'Business interruption and loss of gross profits due to insured perils'
    ],
    exclusions: [
      'Normal wear and tear or gradual deterioration',
      'War perils and nuclear radiation contamination',
      'Willful negligence or failure to maintain electrical safety standards',
      'Shortage revealed during routine inventory audits'
    ],
    isActive: true,
  },
  {
    _id: 'ins_2',
    name: 'Commercial General Liability (CGL)',
    slug: 'commercial-general-liability',
    category: 'liability',
    partner: {
      _id: 'p_2',
      name: 'Tata AIG General Insurance',
      logo: '/partners/tata-aig.png',
    },
    description: 'Essential corporate shield against third-party bodily injury, property damage claims, and product liability arising out of everyday business operations.',
    minPremium: 3499,
    maxPremium: 30000,
    coverageDetails: [
      'Third-party bodily injury occurring on business premises',
      'Third-party property damage caused during operations or installations',
      'Product liability for manufacturing defects and consumer claims',
      'Legal defense costs, advocate retainers, and court settlement expenses',
      'Cross-liability coverage for multi-site commercial enterprises'
    ],
    exclusions: [
      'Intentional non-compliance with statutory product safety standards',
      'Contractual liability without prior underwriter endorsement',
      'Pollution claims unless sudden, accidental, and reported within 72 hours',
      'Professional advice errors (covered under Errors & Omissions instead)'
    ],
    isActive: true,
  },
  {
    _id: 'ins_3',
    name: 'MSME Cyber & Ransomware Defense',
    slug: 'msme-cyber-ransomware-defense',
    category: 'cyber',
    partner: {
      _id: 'p_3',
      name: 'HDFC ERGO General Insurance',
      logo: '/partners/hdfc-ergo.png',
    },
    description: 'Specialized digital risk protection against ransomware extortion, cloud data breaches, phishing spoofing, business email compromise, and forensic restoration expenses.',
    minPremium: 5999,
    maxPremium: 60000,
    coverageDetails: [
      'Ransomware negotiation assistance and extortion mitigation reimbursement',
      'Forensic IT investigation and root cause cyber audit costs',
      'Customer notification costs and legal counsel representation fees',
      'Business email compromise (wire fraud & fake invoice redirection)',
      'Data restoration and cloud server backup re-indexing expenses'
    ],
    exclusions: [
      'Unlicensed or pirated software vulnerabilities without valid licenses',
      'Prior cyber incidents known before the inception date of the policy',
      'Cryptocurrency speculative trading losses or decentralized wallet theft',
      'Hardware degradation unrelated to direct malware execution'
    ],
    isActive: true,
  },
  {
    _id: 'ins_4',
    name: 'Key Person & Founder Life/Health Guard',
    slug: 'key-person-founder-guard',
    category: 'key_person',
    partner: {
      _id: 'p_4',
      name: 'Bajaj Allianz Life & General',
      logo: '/partners/bajaj.png',
    },
    description: 'Safeguard your enterprise valuation and loan collateral against unexpected demise or critical medical illness of key technical leads, managing directors, and co-founders.',
    minPremium: 8499,
    maxPremium: 75000,
    coverageDetails: [
      'High-value term cover paid directly to the company treasury or loan account',
      '36 critical illness lump-sum pay-outs (stroke, cardiac arrest, cancer)',
      'Emergency executive air ambulance and overseas hospitalization cover',
      'Interim bridge salary compensation to hire transition leadership',
      'Tax deductible corporate premiums under Section 37(1) of the Income Tax Act'
    ],
    exclusions: [
      'Pre-existing critical health conditions not disclosed in initial health declaration',
      'Hazardous adventure sports and reckless non-commercial piloting',
      'Self-inflicted injuries or substance abuse complications',
      'Exit from enterprise employment prior to claim date'
    ],
    isActive: true,
  },
  {
    _id: 'ins_5',
    name: 'Comprehensive MSME Business Shield',
    slug: 'comprehensive-msme-business-shield',
    category: 'general',
    partner: {
      _id: 'p_5',
      name: 'Acko General Insurance',
      logo: '/partners/acko.png',
    },
    description: 'All-in-one bundled umbrella policy combining property fire cover, cash-in-transit robbery protection, employee fidelity guarantee, and tenant liability.',
    minPremium: 2999,
    maxPremium: 25000,
    coverageDetails: [
      'Building structure and tenant improvements against fire and flood',
      'Cash-in-transit, safe robbery, and money counter burglary',
      'Employee theft and fraudulent financial manipulation (Fidelity cover)',
      'Public liability for walk-in retail customers and office visitors',
      'Accidental breakage of plate glass, neon signs, and commercial facades'
    ],
    exclusions: [
      'Normal wear, rust, corrosion, or atmospheric dampness',
      'Losses discovered during routine stock counting',
      'Unattended money left outside locked company safe during non-business hours',
      'Losses due to delay, market condition drop, or loss of market share'
    ],
    isActive: true,
  }
];
